import Prevention from '../../../../components/customer/prevention/prevention/Prevention'

const AEACustomerPrevention = () => {
    return <Prevention />
}

export default AEACustomerPrevention
